class Api {
  static actionTypeEnum = {
    read: "read",
    update: "update",
  };

  levelId = {};
  isStandAlone = null;
  baseUrl = "";

  constructor(auth) {
    this.levelId = {
      realm: auth.realm?.id,
      org: auth.orgs?.id,
      site: auth.sites?.id,
    };
    this.isStandAlone = this._checkStandAlone();
    this.baseUrl = this._getBaseUrl();

    Api.instance = this;
  }

  static init(auth) {
    Api.instance = null;
    return new Api(auth);
  }

  _checkStandAlone = () => {
    return !this.levelId.org || Object.keys(this.levelId.org).length === 0;
  };

  _getBaseUrl() {
    return this.isStandAlone
      ? "/orgs/:orgId/sites/:siteId"
      : "/ents/:entId/orgs/:orgId/sites/:siteId";
  }

  getRequestParams(method = Api.actionTypeEnum.read) {
    const params = this.isStandAlone
      ? { orgId: this.levelId.realm, siteId: this.levelId.site }
      : {
        entId: this.levelId.realm,
        orgId: this.levelId.org,
        siteId: this.levelId.site,
      };

    const url = `${this.baseUrl}/settings/wiredIpAcls`;

    return {
      apiKey: `${url}.${method}`,
      params,
    };
  }
}

export default Api;
